<template>
  <Grid
    class="brands-grid"
    :data-items="brands"
    :columns="columns"
    :loader="loading"
    data-cy="brands-grid"
  >
    <template v-slot:NameCell="{ props: { dataItem, field } }">
      <td class="k-table-td">
        <span class="brands-grid__name">{{ dataItem[field] }}</span>
      </td>
    </template>
    <template v-slot:AddressCell="{ props: { dataItem } }">
      <td class="k-table-td">
        <span
          >{{ dataItem.CompanyName }} {{ dataItem.PrivateLabelType }}
          {{ dataItem.IsPendingPla }}</span
        >
      </td>
    </template>
  </Grid>
</template>

<script setup lang="ts">
import { Grid } from "@progress/kendo-vue-grid";
import { ref } from "vue";
import type { GridColumnPropsExtended } from "@/Domain/GridColumnPropsExtended";
import type { BrandNameAndCompanyIdAndName } from "@/Domain/BrandNameAndCompanyIdAndName";

defineProps<{
  brands: BrandNameAndCompanyIdAndName[];
  loading?: boolean;
}>();

const columns = ref<GridColumnPropsExtended[]>([
  {
    title: "Name",
    field: "Brand",
    cell: "NameCell",
  },
  {
    title: "Info",
    field: "CommpanyName",
    cell: "AddressCell",
  },
]);
</script>

<style scoped lang="scss">
.brands-grid {
  min-height: 100px;
  max-height: 350px;

  .brands-grid__name {
    color: #337ab7;
  }
}
</style>
